module.exports = __webpack_public_path__ + "img/hat.ae8301ad.png";